export default {

  password: {
    label: 'Mot de passe actuel',
    infoText: "Par mesure de sécurité, veuillez confirmer votre mot de passe actuel avant d'enregistrer les changements.",
  },

};
